var _module_exports = "<div class=\"page\"\n   ng-class=\"{active: $ctrl.isActivePage, nonactive: !$ctrl.isActivePage}\"\n   ng-include=\"$ctrl.page.view\">\n\n</div>";;
var path = '/components/experience/editor/editor-page.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;